export default __webpack_public_path__ + "static/milo-5b24e387545e7cb5084b131f3efe9b21.jpg";